var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1FBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 15H23.3334V14.1667C23.3322 13.2467 22.5867 12.5012 21.6667 12.5H18.3334C17.4134 12.5012 16.6679 13.2467 16.6667 14.1667V15H13.75C12.5999 15.0011 11.6678 15.9332 11.6667 17.0833V25.4167C11.6678 26.5668 12.5999 27.4989 13.75 27.5H26.25C27.4002 27.4989 28.3323 26.5668 28.3334 25.4167V17.0833C28.3323 15.9332 27.4002 15.0011 26.25 15ZM17.5 14.1667C17.5003 13.7066 17.8733 13.3336 18.3334 13.3333H21.6667C22.1268 13.3336 22.4997 13.7066 22.5 14.1667V15H17.5V14.1667ZM27.5 25.4167C27.4993 26.1067 26.9401 26.6659 26.25 26.6667H13.75C13.06 26.6659 12.5008 26.1067 12.5 25.4167V20.0228L17.3682 21.6455C17.4108 21.6594 17.4553 21.6666 17.5 21.6667H22.5C22.5448 21.6666 22.5893 21.6594 22.6319 21.6455L27.5 20.0228V25.4167ZM27.5 19.1716C27.4562 19.1716 27.412 19.1732 27.3682 19.1878L22.4325 20.8333H17.5676L12.6319 19.1878C12.5881 19.1732 12.5438 19.1716 12.5 19.1716V17.0833C12.5008 16.3933 13.06 15.8341 13.75 15.8333H26.25C26.9401 15.8341 27.4993 16.3933 27.5 17.0833V19.1716Z",
    fill: "#003E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkExperience);
export default __webpack_public_path__ + "static/media/Work_experience.ca0a1a190a02abf2388712ea9d89fbc4.svg";
export { ForwardRef as ReactComponent };